var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(-6.243 -7.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Tag",
    transform: "translate(9.875 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-129",
    d: "M-61.924-354.275a1.892,1.892,0,0,1-1.351-.556l-5.284-5.284a1.894,1.894,0,0,1,0-2.7l7.071-7.071A4.216,4.216,0,0,1-58.826-371H-54.3a1.933,1.933,0,0,1,1.907,1.907v4.529A4.216,4.216,0,0,1-53.5-361.9l-7.071,7.071a1.892,1.892,0,0,1-1.351.556Zm3.1-15.533a3.126,3.126,0,0,0-1.827.755l-7.071,7.071a.7.7,0,0,0,0,.993l5.284,5.284a.7.7,0,0,0,.993,0l7.071-7.071a3.024,3.024,0,0,0,.755-1.827v-4.529a.712.712,0,0,0-.715-.715h-4.489Z",
    transform: "translate(69.125 371)",
    fill: "#e62237"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-130",
    d: "M-42.556-360.212a2.348,2.348,0,0,1-2.344-2.344,2.348,2.348,0,0,1,2.344-2.344,2.348,2.348,0,0,1,2.344,2.344,2.348,2.348,0,0,1-2.344,2.344Zm0-3.575a1.238,1.238,0,0,0-1.232,1.232,1.238,1.238,0,0,0,1.232,1.232,1.238,1.238,0,0,0,1.232-1.232,1.238,1.238,0,0,0-1.232-1.232Z",
    transform: "translate(54.524 367.323)",
    fill: "#e62237"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.e753b31510bf07040e4d6a4335beb465.svg";
export { ForwardRef as ReactComponent };